/* eslint-disable */
// @ts-nocheck
// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as Options2, TDataShape } from './client';
import { client } from './client.gen';
import type { BeginDocUploadRequestData, BeginDocUploadRequestResponses, BeginPaymentMethodVerificationData, BeginPaymentMethodVerificationResponses, ConfirmEmailOtpRequestData, ConfirmEmailOtpRequestResponses, ConfirmPhoneNumberVerificationRequestData, ConfirmPhoneNumberVerificationRequestResponses, CreateEmailOtpRequestData, CreateEmailOtpRequestResponses, CreateOtpTriggerRuleRequestData, CreateOtpTriggerRuleRequestResponses, CreatePhoneNumberVerificationRequestData, CreatePhoneNumberVerificationRequestResponses, CreateSoftKycVerificationRequestData, CreateSoftKycVerificationRequestResponses, GetAccountPhoneNumberDetailsRequestData, GetAccountPhoneNumberDetailsRequestResponses, GetCardVerificationsRequestData, GetCardVerificationsRequestResponses, GetConfirmedKycInfoRequestData, GetConfirmedKycInfoRequestResponses, GetDocUploadHistoryRequestData, GetDocUploadHistoryRequestResponses, GetDocUploadInfoRequestData, GetDocUploadInfoRequestResponses, GetFraudInboxNotificationsData, GetFraudInboxNotificationsResponses, GetKycInfoRequestData, GetKycInfoRequestResponses, GetKycInfoRequestV2Data, GetKycInfoRequestV2Responses, GetKycSettingsRequestData, GetKycSettingsRequestResponses, GetKycVerificationInfoRequestData, GetKycVerificationInfoRequestResponses, GetLiveChatSettingsRequestData, GetLiveChatSettingsRequestResponses, GetSignUpFraudInfoData, GetSignUpFraudInfoResponses, GetSkipOtpCheckRequestData, GetSkipOtpCheckRequestResponses, GetSkipOtpCheckRequestV2Data, GetSkipOtpCheckRequestV2Responses, GetZendeskAuthTokenRequestData, GetZendeskAuthTokenRequestResponses, SaveChatEventRequestData, SaveChatEventRequestResponses, SetAccountFraudInfoData, SetAccountFraudInfoResponses, SetKycInfoRequestData, SetKycInfoRequestResponses, SetKycInfoRequestV2Data, SetKycInfoRequestV2Responses, UpdateFraudInboxNotificationData, UpdateFraudInboxNotificationResponses, UpdateKycInfoRequestData, UpdateKycInfoRequestResponses, UpdateKycInfoRequestV2Data, UpdateKycInfoRequestV2Responses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = Options2<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * SetAccountFraudInfoRequest
 *
 * Update seon fingerprint for a given accountId. This endpoint allows for the updating of fraud information associated with an account. Now used because this separate endpoint because we can't pass seon fingerprint via Prizeout callbacks.
 */
export const setAccountFraudInfo = <ThrowOnError extends boolean = false>(options: Options<SetAccountFraudInfoData, ThrowOnError>) => (options.client ?? client).post<SetAccountFraudInfoResponses, unknown, ThrowOnError>({
    url: '/v1/dispatch/SetAccountFraudInfoRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * CreatePhoneNumberVerificationRequest
 *
 * Create phone verification of given phone number for user
 */
export const createPhoneNumberVerificationRequest = <ThrowOnError extends boolean = false>(options: Options<CreatePhoneNumberVerificationRequestData, ThrowOnError>) => (options.client ?? client).post<CreatePhoneNumberVerificationRequestResponses, unknown, ThrowOnError>({
    url: '/v1/dispatch/CreatePhoneNumberVerificationRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * CreatePhoneNumberVerificationRequest
 *
 * Confirm phone verification of given phone number for user
 */
export const confirmPhoneNumberVerificationRequest = <ThrowOnError extends boolean = false>(options: Options<ConfirmPhoneNumberVerificationRequestData, ThrowOnError>) => (options.client ?? client).post<ConfirmPhoneNumberVerificationRequestResponses, unknown, ThrowOnError>({
    url: '/v1/dispatch/ConfirmPhoneNumberVerificationRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * GetAccountPhoneNumberDetailsRequest
 *
 * Get account phone number verification details, such as country code
 */
export const getAccountPhoneNumberDetailsRequest = <ThrowOnError extends boolean = false>(options: Options<GetAccountPhoneNumberDetailsRequestData, ThrowOnError>) => (options.client ?? client).post<GetAccountPhoneNumberDetailsRequestResponses, unknown, ThrowOnError>({
    url: '/v1/dispatch/GetAccountPhoneNumberDetailsRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * OtpModalTriggeredRequest
 *
 * Create otp trigger rule
 */
export const createOtpTriggerRuleRequest = <ThrowOnError extends boolean = false>(options: Options<CreateOtpTriggerRuleRequestData, ThrowOnError>) => (options.client ?? client).post<CreateOtpTriggerRuleRequestResponses, unknown, ThrowOnError>({
    url: '/v1/dispatch/OtpModalTriggeredRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * GetCardVerificationsRequest
 *
 * Get all user card verifications
 */
export const getCardVerificationsRequest = <ThrowOnError extends boolean = false>(options: Options<GetCardVerificationsRequestData, ThrowOnError>) => (options.client ?? client).post<GetCardVerificationsRequestResponses, unknown, ThrowOnError>({
    url: '/v1/dispatch/GetCardVerificationsRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * BeginPaymentMethodVerificationRequest
 *
 * If order is marked as needs verification, you need to initiate payment method verification using this call.
 */
export const beginPaymentMethodVerification = <ThrowOnError extends boolean = false>(options: Options<BeginPaymentMethodVerificationData, ThrowOnError>) => (options.client ?? client).post<BeginPaymentMethodVerificationResponses, unknown, ThrowOnError>({
    url: '/v1/dispatch/BeginPaymentMethodVerificationRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * GetLiveChatSettingsRequest
 *
 * Get live chat settings request
 */
export const getLiveChatSettingsRequest = <ThrowOnError extends boolean = false>(options: Options<GetLiveChatSettingsRequestData, ThrowOnError>) => (options.client ?? client).post<GetLiveChatSettingsRequestResponses, unknown, ThrowOnError>({
    url: '/v1/dispatch/GetLiveChatSettingsRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * SaveChatEventRequest
 *
 * Chat event
 */
export const saveChatEventRequest = <ThrowOnError extends boolean = false>(options: Options<SaveChatEventRequestData, ThrowOnError>) => (options.client ?? client).post<SaveChatEventRequestResponses, unknown, ThrowOnError>({
    url: '/v1/dispatch/SaveChatEventRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * GetSkipOtpCheckRequest
 *
 * Get skip otp check request
 */
export const getSkipOtpCheckRequest = <ThrowOnError extends boolean = false>(options: Options<GetSkipOtpCheckRequestData, ThrowOnError>) => (options.client ?? client).post<GetSkipOtpCheckRequestResponses, unknown, ThrowOnError>({
    url: '/v1/dispatch/GetSkipOtpCheckRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * GetSkipOtpCheckRequest
 *
 * Get skip otp check request
 */
export const getSkipOtpCheckRequestV2 = <ThrowOnError extends boolean = false>(options: Options<GetSkipOtpCheckRequestV2Data, ThrowOnError>) => (options.client ?? client).post<GetSkipOtpCheckRequestV2Responses, unknown, ThrowOnError>({
    url: '/v2/dispatch/GetSkipOtpCheckRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * GetSignUpFraudInfoRequest
 *
 * Get account fraud information from sign up including VPN detection status
 */
export const getSignUpFraudInfo = <ThrowOnError extends boolean = false>(options: Options<GetSignUpFraudInfoData, ThrowOnError>) => (options.client ?? client).post<GetSignUpFraudInfoResponses, unknown, ThrowOnError>({
    url: '/v1/dispatch/GetSignUpFraudInfoRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * GetFraudInboxNotificationsRequest
 *
 * Get fraud inbox notifications
 */
export const getFraudInboxNotifications = <ThrowOnError extends boolean = false>(options: Options<GetFraudInboxNotificationsData, ThrowOnError>) => (options.client ?? client).post<GetFraudInboxNotificationsResponses, unknown, ThrowOnError>({
    url: '/v1/dispatch/GetFraudInboxNotificationsRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * UpdateFraudInboxNotificationRequest
 *
 * FE should call this method to update status of notification returned in [Get inbox notifications](#operation/getFraudInboxNotifications).
 */
export const updateFraudInboxNotification = <ThrowOnError extends boolean = false>(options: Options<UpdateFraudInboxNotificationData, ThrowOnError>) => (options.client ?? client).post<UpdateFraudInboxNotificationResponses, unknown, ThrowOnError>({
    url: '/v1/dispatch/UpdateFraudInboxNotificationRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * GetKYCInfoRequest
 *
 * FE should call this method to get KYC info
 */
export const getKycInfoRequest = <ThrowOnError extends boolean = false>(options: Options<GetKycInfoRequestData, ThrowOnError>) => (options.client ?? client).post<GetKycInfoRequestResponses, unknown, ThrowOnError>({
    url: '/v1/dispatch/GetKYCInfoRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * GetKYCInfoRequest
 *
 * FE should call this method to get KYC info
 */
export const getKycInfoRequestV2 = <ThrowOnError extends boolean = false>(options: Options<GetKycInfoRequestV2Data, ThrowOnError>) => (options.client ?? client).post<GetKycInfoRequestV2Responses, unknown, ThrowOnError>({
    url: '/v2/dispatch/GetKYCInfoRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * GetKYCSettingsRequest
 *
 * FE should call this method to get KYC settings
 */
export const getKycSettingsRequest = <ThrowOnError extends boolean = false>(options: Options<GetKycSettingsRequestData, ThrowOnError>) => (options.client ?? client).post<GetKycSettingsRequestResponses, unknown, ThrowOnError>({
    url: '/v1/dispatch/GetKYCSettingsRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * GetConfirmedKYCInfoRequest
 *
 * Returns confirmed account KYC info
 */
export const getConfirmedKycInfoRequest = <ThrowOnError extends boolean = false>(options: Options<GetConfirmedKycInfoRequestData, ThrowOnError>) => (options.client ?? client).post<GetConfirmedKycInfoRequestResponses, unknown, ThrowOnError>({
    url: '/v1/dispatch/GetConfirmedKYCInfoRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * SetKYCInfoRequest
 *
 * FE should call this method to update KYC info
 */
export const setKycInfoRequest = <ThrowOnError extends boolean = false>(options: Options<SetKycInfoRequestData, ThrowOnError>) => (options.client ?? client).post<SetKycInfoRequestResponses, unknown, ThrowOnError>({
    url: '/v1/dispatch/SetKYCInfoRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * SetKYCInfoRequest
 *
 * FE should call this method to update KYC info
 */
export const setKycInfoRequestV2 = <ThrowOnError extends boolean = false>(options: Options<SetKycInfoRequestV2Data, ThrowOnError>) => (options.client ?? client).post<SetKycInfoRequestV2Responses, unknown, ThrowOnError>({
    url: '/v2/dispatch/SetKYCInfoRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * UpdateKYCInfoRequest
 *
 * FE should call this method to update KYC info
 */
export const updateKycInfoRequest = <ThrowOnError extends boolean = false>(options: Options<UpdateKycInfoRequestData, ThrowOnError>) => (options.client ?? client).post<UpdateKycInfoRequestResponses, unknown, ThrowOnError>({
    url: '/v1/dispatch/UpdateKYCInfoRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * UpdateKYCInfoRequest
 *
 * FE should call this method to update KYC info
 */
export const updateKycInfoRequestV2 = <ThrowOnError extends boolean = false>(options: Options<UpdateKycInfoRequestV2Data, ThrowOnError>) => (options.client ?? client).post<UpdateKycInfoRequestV2Responses, unknown, ThrowOnError>({
    url: '/v2/dispatch/UpdateKYCInfoRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * GetZendeskAuthTokenRequest
 *
 * generates JWT token for Zendesk authorization
 */
export const getZendeskAuthTokenRequest = <ThrowOnError extends boolean = false>(options: Options<GetZendeskAuthTokenRequestData, ThrowOnError>) => (options.client ?? client).post<GetZendeskAuthTokenRequestResponses, unknown, ThrowOnError>({
    url: '/v1/dispatch/GetZendeskAuthTokenRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * GetDocUploadInfoRequest
 *
 * returns available document types to upload
 */
export const getDocUploadInfoRequest = <ThrowOnError extends boolean = false>(options: Options<GetDocUploadInfoRequestData, ThrowOnError>) => (options.client ?? client).post<GetDocUploadInfoRequestResponses, unknown, ThrowOnError>({
    url: '/v1/dispatch/GetDocUploadInfoRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * BeginDocUploadRequest
 *
 * returns available document types to upload
 */
export const beginDocUploadRequest = <ThrowOnError extends boolean = false>(options: Options<BeginDocUploadRequestData, ThrowOnError>) => (options.client ?? client).post<BeginDocUploadRequestResponses, unknown, ThrowOnError>({
    url: '/v1/dispatch/BeginDocUploadRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * GetDocUploadHistoryRequest
 *
 * returns doc upload history
 */
export const getDocUploadHistoryRequest = <ThrowOnError extends boolean = false>(options: Options<GetDocUploadHistoryRequestData, ThrowOnError>) => (options.client ?? client).post<GetDocUploadHistoryRequestResponses, unknown, ThrowOnError>({
    url: '/v1/dispatch/GetDocUploadHistoryRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * CreateEmailOtpRequest
 *
 * create email otp request
 */
export const createEmailOtpRequest = <ThrowOnError extends boolean = false>(options: Options<CreateEmailOtpRequestData, ThrowOnError>) => (options.client ?? client).post<CreateEmailOtpRequestResponses, unknown, ThrowOnError>({
    url: '/v1/dispatch/CreateEmailOtpRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * ConfirmEmailOtpRequest
 *
 * create email otp request
 */
export const confirmEmailOtpRequest = <ThrowOnError extends boolean = false>(options: Options<ConfirmEmailOtpRequestData, ThrowOnError>) => (options.client ?? client).post<ConfirmEmailOtpRequestResponses, unknown, ThrowOnError>({
    url: '/v1/dispatch/ConfirmEmailOtpRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * GetKYCVerificationInfoRequest
 *
 * Get kyc verification info
 */
export const getKycVerificationInfoRequest = <ThrowOnError extends boolean = false>(options: Options<GetKycVerificationInfoRequestData, ThrowOnError>) => (options.client ?? client).post<GetKycVerificationInfoRequestResponses, unknown, ThrowOnError>({
    url: '/v1/dispatch/GetKYCVerificationInfoRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * CreateSoftKycVerificationRequest
 *
 * Create soft KYC verification request
 */
export const createSoftKycVerificationRequest = <ThrowOnError extends boolean = false>(options: Options<CreateSoftKycVerificationRequestData, ThrowOnError>) => (options.client ?? client).post<CreateSoftKycVerificationRequestResponses, unknown, ThrowOnError>({
    url: '/v1/dispatch/CreateSoftKycVerificationRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
